export const createAction = type => (payload) => ({ type, payload });


// WEBPACK FOOTER //
// ./src/reducers/util.js